const onlyUnique = (value, index, self) => self.indexOf(value) === index;

export const getProcessAutoCompleteOptions = (attribute, processes) =>
  processes
    .map((process) => process[attribute])
    .filter(Boolean)
    .filter(onlyUnique)
    .map((value) => ({ label: value, value }));
